import React from "react";

const ServiceTipsCard = (props) => {
  return (
    <div className="col-12 col-md-6 col-xl-3 revamp-reveal" style={{marginBottom: '24px'}}>
        <div className="revamp-tip-card">
            <div className="revamp-tip-number">
                {props.id}
            </div>
            <div className="content"> 
                <h3>{props.caption}</h3>
                <p>{props.detail}</p>
            </div>
        </div>
    </div>
  );
};

export default ServiceTipsCard;